import { gql } from 'apollo-angular';

export const getExternalDeviceStatus = gql`
  query getExternalSystemStatus {
    getExternalSystemStatus {
      accountId
      description
      currentState {
        status
        timestamp
      }
      previousState {
        status
        timestamp
      }
      metaData {
        lineId
        lineName
      }
      subTitle
      title
      systemInfo
      type
    }
  }
`;
